// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"14":"895966d1","568":"75c141b2"}[chunkId] + ".chunk.js";
};